import React from 'react';
import { useModal, UserContactCardProps } from '@europrocurement/flexy-components';
import UserContactCard from '@europrocurement/flexy-components/components/organisms/UserContactCard/UserContactCard';
import { useModalMail } from '@europrocurement/l2d-modules/modules/MailForm';

const useUserContactCard = () => {
    const { modalActions } = useModal();
    const { showMailModal } = useModalMail();

    const callUserContactCardModal = async (userContactCardProps: UserContactCardProps) => {
        modalActions.call(
            <UserContactCard
                {...userContactCardProps}
                defaultMailAction={showMailModal}
            />,
        );
    };
    return { callUserContactCardModal };
};

export default useUserContactCard;
